import React, { useState } from "react";
import { DialogContent } from "@mui/material";
import { DialogContentContainer } from "../../../../../pages/user/balance/top-up-dialog/styled";
import { StandardDialogFooter } from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { useAppSelector } from "../../../../../redux/store";
import BarekamInput from "../../../../../pages/components/input";
import { Message, MessageSections } from "../../../../../pages/components/message/message";
import balanceService from "../../../../../services/balance-service";
import { getMessage } from "../../../../../pages/shared/helper-functions";

const AdminTopUpDialog = ({ userId, onClose }: TopUpDialogProps) => {
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const [amount, setAmount] = useState<number | null>(null);
    const [topUpReason, setTopUpReason] = useState<string | null>(null);
    const [amountError, setAmountError] = useState<string>();
    const [topUpReasonError, setTopUpReasonError] = useState<string>();

    function submitPayment() {
        if (!amount) {
            setAmountError('required');
        } else if (!topUpReason) {
            setTopUpReasonError('required');
        } else {
            balanceService.refill(userId, amount, topUpReason)
                .then(() => {
                    onClose(true);
                })
        }
    }

    return (
        <>
            <DialogContent>
                <DialogContentContainer>
                    <BarekamInput value={amount || ''}
                        placeholder={getMessage('amount_amd', MessageSections.MAIN, messageCache, languageId)}
                        label={getMessage('amount_amd', MessageSections.MAIN, messageCache, languageId)}
                        type={"number"}
                        customInputVariant={"standard"}
                        width={'100%'}
                        onChange={(event) => setAmount(+event.target.value)}
                        error={!!amountError}
                        errorMessage={amountError && getMessage(amountError, MessageSections.ORDERS, messageCache, languageId)}
                        required />

                    <BarekamInput value={topUpReason || ''}
                        placeholder={getMessage('top_up_reason', MessageSections.MAIN, messageCache, languageId)}
                        label={getMessage('top_up_reason', MessageSections.MAIN, messageCache, languageId)}
                        type={"string"}
                        customInputVariant={"standard"}
                        width={'100%'}
                        onChange={(event) => setTopUpReason(event.target.value)}
                        error={!!topUpReasonError}
                        errorMessage={topUpReasonError && getMessage(topUpReasonError, MessageSections.ORDERS, messageCache, languageId)}
                        required />
                </DialogContentContainer>
            </DialogContent>
            <StandardDialogFooter
                saveLabel={<Message messageKey={'refill_balance'} sectionId={MessageSections.MAIN} />}
                onSave={submitPayment}
                onCancel={() => onClose(false)} />
        </>
    )
}

interface TopUpDialogProps {
    userId: number,
    onClose: (withUpdate: boolean) => void,
}

export default AdminTopUpDialog;
